import React, { Component } from 'react';
import IntelligentHeader from "../../components/IntelligentAllMajorModal/components/IntelligentHeader";
import IntelligentMajorDetail from "./components/IntelligentMajorDetail";
import './style.css';
import '../../../../../index.css';
class IntelligenMajorModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      css: {},
    };
  }
  componentDidMount() {
    this.fixCss();
  }
  render() {
    const { majorData, visible, handleVisibleMajor } = this.props;
    return (
      <div
        style={{ minHeight: this.state.css.minHeight }}
        className={
          visible === true
            ? "intelligentAllMajorModal_box"
            : "intelligentAllMajorModal_box display_none"
        }
      >
        <IntelligentHeader
          handleVisible={handleVisibleMajor}
        ></IntelligentHeader>
        {majorData != null ? (
          <IntelligentMajorDetail item={majorData}></IntelligentMajorDetail>
        ) : (
          ""
        )}
      </div>
    );
  }
  fixCss = () => {
    let minHeight = window.innerHeight;
    this.setState({
      css: {
        minHeight: minHeight,
      },
    });
  };
}

export default IntelligenMajorModal;


// WEBPACK FOOTER //
// ./src/containers/IntelligentBigData/IntelligentBigDataHome/components/IntelligentMajorModal/index.js